var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "uagbubam6a",
  x1: "50%",
  x2: "50%",
  y1: "1.421%",
  y2: "123.039%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#016DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1733DB"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "url(#uagbubam6a)",
  transform: "translate(-487 -220)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M496 230.91c4.97 0 9 4.07 9 9.09h-18c0-5.02 4.03-9.09 9-9.09zm0-10.91c2.485 0 4.5 2.035 4.5 4.545s-2.015 4.546-4.5 4.546-4.5-2.035-4.5-4.546c0-2.51 2.015-4.545 4.5-4.545z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export default ForwardRef;